import { render, staticRenderFns } from "./MealConfigurationSummary.vue?vue&type=template&id=02facebf&scoped=true"
import script from "./MealConfigurationSummary.vue?vue&type=script&lang=js"
export * from "./MealConfigurationSummary.vue?vue&type=script&lang=js"
import style0 from "./MealConfigurationSummary.vue?vue&type=style&index=0&id=02facebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02facebf",
  null
  
)

export default component.exports